import React from 'react';

class Sources extends React.Component {
  render() {
    return (
      <div>
        <div className="modal" id="sources" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 className="modal-title" id="myModalLabel">Sources</h4>
              </div>
              <div className="modal-body">
                <div className="container-fluid">
                  <h4 className="title">Temperatures and precipitations</h4>
                  <p><strong>For countries:</strong></p>
                  <p><a href="http://sdwebx.worldbank.org/climateportal/" target="_blank">The World Bank Group</a>'s <a href="https://datahelpdesk.worldbank.org/knowledgebase/articles/902061-climate-data-api" target="_blank">historical averages</a> for 1901-2009.</p>
                  <p>"These data [...] are based on gridded climatologies from the Climate Research Unit. [...] modeling has been used to extrapolate estimates where instrumental (station) data were unavailable or unreliable, especially in the early 1900's."</p>
                  <p><strong>For climate zones:</strong></p>
                  <p><a href="http://sdwebx.worldbank.org/climateportal/" target="_blank">The World Bank Group</a>'s <a href="http://sdwebx.worldbank.org/climateportal/index.cfm?page=forthcoming_downscaled_data" target="_blank">downscaled data</a> for 1961-1999.</p>
                  <p>"This gridded historical dataset is derived from observational data, and provides quality controlled temperature and rainfall values from thousands of weather stations worldwide, as well as derivative products including monthly climatologies and long term historical climatologies."</p>
                  <h4 className="title">Recommendations</h4>
                  <p>The "Best weather" indicator is based on average temperatures and precipitations. It defines a weather that is not too cold, not too hot, and not too rainy.</p>
                  <p>
                    <img src={require('../images/scale.png')} alt="" className="img-responsive scale" />
                    <img src={require('../images/scale-mobile.png')} alt="" className="img-responsive scale-mobile" />
                  </p>
                  <h4 className="title">Flight prices</h4>
                  <p>Quotes are provided by <a href="https://www.skyscanner.com" target="_blank">Skyscanner</a> through its <a href="https://skyscanner.github.io/slate/#browse-dates" target="_blank">API</a>. These are cached estimates which can be up to one day old. For real time data, click the link to Skyscanner.</p>
                  <p>ClimateList is registered as a Skyscanner affiliate. It may become eligible to earn a commission from sales when it starts generating enough traffic.</p>
                  <p>
                    <a href="https://www.skyscanner.com" target="_blank">
                      <img src={require('../images/skyscanner.png')} alt="" className="img-responsive skyscanner" />
                    </a>
                  </p>
                  <h4 className="title">Geolocation</h4>
                  <p>The user's country is detected with <a href="http://dev.maxmind.com/geoip/geoip2/geolite2/" target="_blank">MaxMind</a>'s GeoLite2 free database.</p>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Sources;



/** WEBPACK FOOTER **
 ** ./src/components/Sources.js
 **/